import React from 'react';
import {connect} from "react-redux";
import {addComment} from "../../actions/updateFirestoreData/recipesData/addComment";
import {TextField, Button, Grid} from "@material-ui/core";


/**
 * This class is used to add a recipe's comment from one user
 */
class Comment extends React.Component {
    state = {
        commentValue: ""
    };

    validComment = async () => {
        const {auth} = this.props.auth;
        let text = this.state.commentValue;
        let {recipeName} = this.props;
        await this.props.addComment({
            userPseudo: auth.pseudo,
            recipeName: recipeName,
            text: text
        });
    };

    render() {
        return (
            <div style={{marginTop: 10}}>
                <Grid item>
                    <TextField
                        fullWidth={true}
                        type="text" name="commentaire" id="commentaire"
                        key="commentaire" label="commentaire" value={this.state.commentValue}
                        onChange={e => this.setState({commentValue: e.target.value})}
                        variant="outlined" multiline rows={4}/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justify='center' style={{marginTop: 5}}>
                        <Grid item>
                            <Button type="submit" variant="contained" color="primary" onClick={this.validComment}>
                                Valider
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        )
    }
}


const mapStateToProps = (auth) => {
    return {auth}
};


export default connect(
    mapStateToProps,
    {addComment}
)(Comment)
